import React from 'react';

import { Button } from '@components/Button';
import { useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    reset: 'リセット',
    notFound: '該当の情報はありません。検索の条件をご確認ください。',
  },
});

export interface ErrorResultProps {
  onAction?: () => void;
  actionTitle?: string;
}

export const ErrorResult: React.FC<React.PropsWithChildren<ErrorResultProps>> = (props) => {
  const { onAction: action, actionTitle = strings.reset, children } = props;

  const classes = {
    ...useCommonStyles(),
  };

  return (
    <div>
      <div className={clsx(classes.middleText, classes.textGray800)}>
        {children ?? strings.notFound}
      </div>
      <div style={{ height: 32 }} />
      <Button
        text={actionTitle}
        color="primary"
        type="submit"
        shape="round"
        size="small"
        onClick={action}
      />
    </div>
  );
};
